import { render, staticRenderFns } from "./AddChequeReturn.vue?vue&type=template&id=372f3604&"
import script from "./AddChequeReturn.vue?vue&type=script&lang=js&"
export * from "./AddChequeReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports